module.exports = __webpack_public_path__ + "images/514d6fa7e82d85e9b5fa335e31cbb1e9-unknown_icon.png";